module.exports = __webpack_public_path__ + "static/comfort_parter-ecc5285d64be46ae50ce7f8318b8a393.jpg";